// blockingSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  resnavigate: false,
  trynavigate: false,
  // Captured destination the user was trying to reach when navigation was blocked.
  // Shape: { kind: 'route', value: '/path' } | { kind: 'tab', value: 'tabKey' }.
  // The component that originally tried to navigate sets this before triggering the
  // block, and consumes it once `resnavigate` is cleared (i.e. after the user
  // confirms Discard) so the original destination is auto-applied without a re-click.
  pendingNavigation: null,
};

const blockingSlice = createSlice({
  name: "blocking",
  initialState,
  reducers: {
    restrictnavigate: (state, action) => {
      state.resnavigate = action.payload === true;
    },
    tryingnavigate: (state, action) => {
      state.trynavigate = action.payload === true;
    },
    setPendingNavigation: (state, action) => {
      state.pendingNavigation = action.payload || null;
    },
    clearPendingNavigation: (state) => {
      state.pendingNavigation = null;
    },
  },
});

export const {
  restrictnavigate,
  tryingnavigate,
  setPendingNavigation,
  clearPendingNavigation,
} = blockingSlice.actions;
export default blockingSlice.reducer;
